module.exports = __webpack_public_path__ + "static/media/mail-unread-filled.99f266f8.svg";